import React from "react";
import { ChevronLeft, ChevronRight, RefreshCw, Target } from "lucide-react";
import PredictNavFoot from "../PredictNavFoot";
import { BP_DETAIL_RAIL_ESCAPE_LINKS } from "../../../utils/bondPredictNavFooter";
import { MARKET_TYPES } from "../../../utils/bondPredictHelpers";
import { getOutcomeLayoutMeta } from "../../../utils/bondPredictDetailHelpers";
import MarketDetailOutcomes from "./MarketDetailOutcomes";

const MarketDetailRail = ({
  market,
  onRefresh,
  refreshing,
  selectedOutcomeId,
  onSelectOutcome,
  collapsed = false,
  onToggleCollapse,
}) => {
  const layoutMeta = market ? getOutcomeLayoutMeta(market) : null;
  const outcomeCount = layoutMeta?.legCount || 0;
  const isMulti = market?.type === MARKET_TYPES.MULTI_BINARY;
  const iconOnly = collapsed;

  return (
    <aside
      className={`bp-predict-nav-rail bp-detail-rail${
        iconOnly ? " bp-predict-nav-rail-collapsed bp-detail-rail-collapsed" : ""
      }`}
      aria-label="Outcomes"
    >
      <div className={`bp-predict-nav-head${iconOnly ? " bp-predict-nav-head-icon-only" : ""}`}>
        <div className="bp-predict-nav-brand">
          <span className="bp-predict-nav-brand-mark" aria-hidden>
            <Target size={15} strokeWidth={2.4} />
          </span>
          {!iconOnly ? (
            <span className="bp-predict-nav-brand-copy">
              <span className="bp-predict-nav-title">Outcomes</span>
              {outcomeCount > 0 ? (
                <span className="bp-predict-nav-tag">
                  <span className="bp-predict-nav-pip" aria-hidden />
                  {outcomeCount} {isMulti ? "lines" : "sides"}
                </span>
              ) : null}
            </span>
          ) : null}
        </div>
        <div className="bp-detail-rail-top-actions">
          {onToggleCollapse ? (
            <button
              type="button"
              className="bp-predict-nav-collapse"
              onClick={onToggleCollapse}
              aria-label={iconOnly ? "Expand outcomes" : "Collapse outcomes"}
              title={iconOnly ? "Expand" : "Collapse"}
            >
              {iconOnly ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
            </button>
          ) : null}
          <button
            type="button"
            className="bp-detail-rail-refresh"
            onClick={onRefresh}
            disabled={refreshing}
            aria-label="Refresh market"
            title="Refresh"
          >
            <RefreshCw size={13} className={refreshing ? "bp-spin" : ""} />
          </button>
        </div>
      </div>

      <div className="bp-predict-nav-scroll bp-detail-rail-scroll">
        <MarketDetailOutcomes
          market={market}
          selectedOutcomeId={selectedOutcomeId}
          onSelectOutcome={onSelectOutcome}
          collapsed={iconOnly}
        />
      </div>

      <PredictNavFoot links={BP_DETAIL_RAIL_ESCAPE_LINKS} iconOnly={iconOnly} />
    </aside>
  );
};

export default MarketDetailRail;
